module.exports = __webpack_public_path__ + "img/main-top-min.8295e1c8.png";